import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LearnerImportSummary } from '../models';

export const usersImporterActions = createActionGroup({
    source: 'Users Importer',
    events: {
        'Import Learners': props<{ schoolId: string; file: File }>(),
        'Import Learners Success': props<{ payload: LearnerImportSummary }>(),
        'Import Learners Error': props<{ code: number }>(),
        'Clear Summary': emptyProps(),
        'Download Template': emptyProps(),
        'Download Template Success': props<{ blob: Blob }>(),
        'Download Template Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
